module.exports = __webpack_public_path__ + "static/media/Notes.51e689cd.png";